<template>
  <DetailsListEntry v-if="!edit" class="ma-0" :title="element.label" :content="model" />
  <TextField
    v-else
    v-model="model"
    :data-test="`input-${element.name}`"
    :title="element.label"
    :blank-title="!element.label"
    :placeholder="element.placeholder"
    :mark="invalid"
  />
</template>

<script lang="ts">
import { logger, TextElement } from '@anschuetz-elog/common';
import { cloneDeep } from 'lodash';
import { computed, defineComponent, PropType, toRef } from 'vue';

import DetailsListEntry from '#/components/DetailsListEntry.vue';
import TextField from '#/components/TextField.vue';

export default defineComponent({
  name: 'FormTextField',

  components: {
    DetailsListEntry,
    TextField,
  },

  props: {
    element: {
      type: Object as PropType<TextElement>,
      required: true,
    },

    value: {
      type: Object as PropType<Record<string, unknown>>,
      required: true,
    },

    edit: {
      type: Boolean,
    },

    invalid: {
      type: Boolean,
    },
  },

  emits: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    input: (_value: Record<string, unknown>) => true,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    invalid: (_invalid: boolean) => true,
  },

  setup(props, { emit }) {
    const value = toRef(props, 'value');
    const element = toRef(props, 'element');

    const model = computed<string | undefined>({
      get() {
        const v = value.value[element.value.name];
        if (v !== undefined && typeof v !== 'string') {
          logger.error(
            'Value does not fit to text element',
            'value:',
            cloneDeep(v),
            'element:',
            cloneDeep(element.value),
          );
          return undefined;
        }
        return v;
      },
      set(newElementValue) {
        emit('input', { ...value.value, [element.value.name]: newElementValue });
      },
    });

    return { model };
  },
});
</script>
